import { filter } from 'lodash-es';

export default {
  /**
   * @param state
   * @returns Array
   */
  filteredXmlChannels(state) {
    const searchWord = state.filter.search;
    const systemFilters = state.filter.system;
    const statusFilters = state.filter.status;
    let xmlChannels = state.xmlChannels.items;

    if (systemFilters) {
      xmlChannels = filter(xmlChannels, xmlChannel => xmlChannel.system === systemFilters);
    }

    if (statusFilters && statusFilters.length > 0) {
      xmlChannels = filter(xmlChannels, (xmlChannel) => {
        for (let i = 0; i < statusFilters.length; i += 1) {
          if (!xmlChannel.latestJob) {
            return statusFilters[i] === 'NO_CONTENT';
          }
          if (xmlChannel.latestJob.status === statusFilters[i]) {
            return true;
          }
        }
        return false;
      });
    }

    if (searchWord) {
      xmlChannels = filter(xmlChannels, (xmlChannel) => {
        const searchIn = xmlChannel.webservice + xmlChannel.system;
        return !!searchIn.includes(searchWord.toUpperCase());
      });
    }

    return xmlChannels;
  },

  /**
   * @param state
   * @param getters
   * @returns Array
   */
  jobStatusList(state, getters) {
    const badges = getters.getBadges;
    return [
      { badge: badges.SUCCESS, values: ['SUCCESS'] },
      { badge: badges.SYNCHRONIZING, values: ['SYNCHRONIZING'] },
      { badge: badges.AWAITING_SYNCHRONIZATION, values: ['AWAITING_SYNCHRONIZATION'] },
      { badge: badges.IMPORTING, values: ['IMPORTING'] },
      { badge: badges.WARNING, values: ['WARNING'] },
      { badge: badges.ERROR, values: ['ERROR', 'SYNC_ERROR'] },
      { badge: badges.TOTAL,
        values:
          [
            'SUCCESS',
            'SYNCHRONIZING',
            'AWAITING_SYNCHRONIZATION',
            'IMPORTING',
            'WARNING',
            'ERROR',
            'SYNC_ERROR',
          ],
      },
    ];
  },

  /**
   * @returns Object
   */
  getBadges() {
    return {
      SUCCESS: { label: 'success', color: 'success', text: 'white' },
      SYNCHRONIZING: { label: 'sync', color: 'cyan lighten-2', text: 'white' },
      AWAITING_SYNCHRONIZATION: { label: 'awaiting_sync', color: 'deep-purple accent-1', text: 'white' },
      IMPORTING: { label: 'importing', color: 'light-blue', text: 'white' },
      WARNING: { label: 'warning', color: 'warning', text: 'white' },
      ERROR: { label: 'error', color: 'error', text: 'white' },
      SYNC_ERROR: { label: 'sync_error', color: 'error', text: 'white' },
      TOTAL: { label: 'total', color: 'secondary', text: 'white' },
      NO_CONTENT: { label: 'no_content', color: 'grey', text: 'white' },
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/xmlChannelStatus/getters.js